import useStates from '@/hooks/api/v2/useStates';

export default function useStandardsStates() {
  return useStates({ params: { has_edgate_data: true } });
}
